import {Component, computed, input} from '@angular/core';
import {NgxSkeletonLoaderModule} from 'ngx-skeleton-loader';
import {SkeletonAppearanceType} from '../../enums/skeleton-appearance.type';

@Component({
  selector: 'cov-skeleton',
  imports: [NgxSkeletonLoaderModule],
  templateUrl: './cov-skeleton.component.html',
  styleUrl: './cov-skeleton.component.scss',
})
export class CovSkeletonComponent {
  public count = input<number>(1);
  public theme = input<Record<string, string>>();

  public appearance = input.required<SkeletonAppearanceType>();

  public realAppearance = computed(() => {
    return this.appearance() === 'circle' ? 'circle' : 'line';
  });

  public mergedTheme = computed(() => {
    const backgroundColor = this.getBackgroundColor(this.appearance());
    return {
      ...this.defaultTheme(),
      backgroundColor,
      ...this.theme(),
    };
  });

  private defaultTheme = computed(() => {
    return {
      'border-radius': this.getBorderRadius(this.appearance()),
    };
  });

  private getBorderRadius(appearance: SkeletonAppearanceType) {
    switch (appearance) {
      case 'circle': {
        return 9999;
      }

      default:
        return 'var(--global-border-radius)';
    }
  }

  private getBackgroundColor(appearance: SkeletonAppearanceType) {
    switch (appearance) {
      case 'circle':
        return 'var(--skeleton-circle-color)';

      case 'headline':
        return 'var(--skeleton-headline-color)';

      case 'subline':
        return 'var(--skeleton-subline-color)';

      case 'text':
        return 'var(--skeleton-text-color)';

      case 'tile':
        return 'var(--skeleton-tile-color)';

      default:
        return 'var(--skeleton-text-color)';
    }
  }
}
